import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component, createRef } from 'intact-vue';
import template from './index.vdt';
import { useAccept } from './useAccept';
import { useUpload, UploadFileStatus } from './useUpload';
import { useFiles } from './useFiles';
import { bind } from '../utils';
import { useDrag } from './useDrag';
import { useShowImage } from './useShowImage';
import { useConfigContext } from '../config';
export { UploadFileStatus };
var typeDefs = {
  accept: String,
  files: Array,
  defaultFiles: Array,
  maxSize: Number,
  limit: Number,
  autoUpload: Boolean,
  beforeRemove: Function,
  beforeUpload: Function,
  data: Object,
  action: String,
  headers: Object,
  name: String,
  withCredentials: Boolean,
  type: ['select', 'drag', 'gallery'],
  directory: Boolean,
  disabled: Boolean,
  multiple: Boolean
};
var defaults = function defaults() {
  return {
    files: [],
    type: 'select',
    autoUpload: true
  };
};
var events = {
  progress: true,
  success: true,
  error: true
};
export var Upload = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Upload, _Component);
  function Upload() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.inputRef = createRef();
    _this.accept = useAccept();
    _this.upload = useUpload();
    _this.files = useFiles(_this.accept.isValidType, _this.upload);
    _this.drag = useDrag(_this.files.addFiles);
    _this.showImage = useShowImage();
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Upload.prototype;
  _proto.submit = function submit() {
    var _this2 = this;
    this.get('files').forEach(function (file) {
      if (file.status === UploadFileStatus.NotReady) {
        _this2.upload(file);
      }
    });
  };
  _proto.selectFile = function selectFile() {
    if (!this.get('disabled')) {
      var input = this.inputRef.value;
      input.value = '';
      input.click();
    }
  };
  _proto.onInputChange = function onInputChange(e) {
    this.files.addFiles(e.target.files);
  };
  return Upload;
}(Component);
Upload.template = template;
Upload.typeDefs = typeDefs;
Upload.defaults = defaults;
Upload.events = events;
__decorate([bind], Upload.prototype, "selectFile", null);
__decorate([bind], Upload.prototype, "onInputChange", null);